import React from 'react';
import i18n from 'i18next';
import moment from 'moment';

const OriginalCrunchClassManager = require('crunch-class-manager').default;

const frClassManagerTranslations = {
  downloads: {
    main_text: "Tu veux sauvegarder tes cours ou instructeurs favoris ? {{booking_action}} Les membres Crunch peuvent faire tout ça à…",
    book_a_class: "Réserver un cours ?",
    view_schedule: "consulter l'horaire des cours ?",
    group_fitness: "Télécharge l'horaire des cours de cette semaine",
    small_group_training: "Télécharge l'horaire des cours HIITZone de cette semaine",
    header: "Les meilleurs cours d’entraînement en groupe",
    ios_app: "Télécharge notre appli membre sur iOS pour accéder facilement aux réservations Crunch en ligne",
    android_app: "Télécharge notre appli membre sur Android pour accéder facilement aux réservations Crunch en ligne"
  },
  messages: {
    classes_found: "cours trouvés",
    having_trouble_booking: "Tu as de la difficulté à réserver des cours ?"
  },
  desktop_headers: {
    find_clases_at: "Trouver des cours à",
    select_locations: "Sélectionner des emplacements",
    edit_add_location: "+ MODIFIER OU AJOUTER DES EMPLACEMENTS"
  },
  location_filters: {
    clear: "Effacer"
  },
  selector: {
    filter: "Filtrer par province / état",
    select: "Sélectionner..."
  },
  mobile_headers: {
    find_class: "Trouver un cours",
    filters: "Filtres"
  },
  reservations: {
    update_reservation: "Modifier ta réservation",
    reservation: "Réservation",
    login_to_reserve: "Se connecter pour réserver une place",
    update_cancel: "Modifier / Annuler la réservation",
    reserve: "RÉSERVER UNE PLACE",
    are_you_sure: "Es-tu certain ?",
    yes: "oui",
    no: "non",
    my_reservations: "MES RÉSERVATIONS",
    less_than_30_min: "Réservations en ligne fermées 30 minutes avant le cours.",
    more_than_22_hours_before: "En dehors de la période de réservation.",
    class_fully_booked: "Le cours est complet",
    class_not_in_membership: "Oups ! Ce cours n'est pas inclus dans ton abonnement.",
    terms_and_conditions_not_accepted: "Tu dois accepter nos Termes & Conditions avant de pouvoir réserver en ligne.",
    membership_not_active: "Ton abonnement n'est pas actif.",
    more_than_5_classes_today: "Tu as atteint le maximum de cinq cours réservés par jour.",
    overlapping_reservation: "Tu as déjà réservé un cours à cette heure.",
    take_me_back: "Fermer"
  },
  reserve: "RÉSERVER",
  update: "MODIFIER",
  cancel: "ANNULER",
  activate: "ACTIVER",
  select_location: {
    find_classes: "Trouver des cours"
  },
  weekdayAttributes: {
    Sunday: { letter: "Di", abbrv: "Dim", full: "Dimanche" },
    Monday: { letter: "L", abbrv: "Lun", full: "Lundi" },
    Tuesday: { letter: "Ma", abbrv: "Mar", full: "Mardi" },
    Wednesday: { letter: "Me", abbrv: "Mer", full: "Mercredi" },
    Thursday: { letter: "J", abbrv: "Jeu", full: "Jeudi" },
    Friday: { letter: "V", abbrv: "Ven", full: "Vendredi" },
    Saturday: { letter: "S", abbrv: "Sam", full: "Samedi" }
  },
  no_location: {
    select_location_begin: "Sélectionne un emplacement pour commencer à chercher des cours.",
    select_location: "Sélectionner un emplacement"
  },
  no_result: {
    heading: "Aucun résultat",
    message: "Essaie de modifier ton emplacement, la date ou tes filtres."
  },
  schedules: {
    spots_left: "places restantes",
    fully_booked: "Complet"
  },
  filter_nav: {
    location: "EMPLACEMENT",
    category: "CATÉGORIE",
    instructor: "INSTRUCTEUR",
    class: "COURS",
    time: "HEURE",
    favorites: "FAVORIS"
  },
  categoryTitle: {
    chisel_it: "Chisel It",
    action_sports: "Sports d'action",
    something_different: "Quelque chose de différent"
  },
  categoryDescription: {
    something_different: "Augmente l'intensité et ajoute un petit plus à ta séance.",
    action_sports: "Prépare-toi à te muscler pour un entraînement complet qui va te motiver!",
    the_ride: "Prêt pour le ride de ta vie ? En selle et fais tourner ces roues!",
    mind_body_burn: "Restaure, réinitialise et rafraîchis.",
    gym_time: "Réserve une place pour t'entraîner dans le gym!",
    cardio_dance: "Bouge au rythme de la musique et ressens l'énergie.",
    chisel_it: "Sculpte, tonifie et transforme ton corps.",
    advanced_hiit: "Transpire lors de nos séances d'entraînement en petits groupes!",
    exclusive: "Des entrarnements exclusifs qui te feront sentir fantastique.",
    aqua: "Des entraînements aquatiques dynamiques combinant cardio et musculation!",
    boxing: "Monte sur le ring et libère le boxeur en toi!",
    cardio: "Une expérience cardio intense garantie de te faire transpirer!",
    dance: "Danse et transpire avec un plaisir contagieux!",
    event: "Un événement fitness unique et dynamique!",
    hiitzone: "Des séances fonctionnelles combinant travail d'équipe, HIIT et force totale.",
    hot_stuff: "Augmente l'intensité avec nos entraînements dans la chaleur.",
    mind_body: "Mouvements conscients, respiration et étirements profonds.",
    mixed: "Un mélange équilibré de cardio et de musculation.",
    specialty: "Des cours spécialisés conçus pour inspirer et élever ton entraînement.",
    strength: "Des séances de musculation pour développer ta force et sculpter ton physique.",
    sweatshed: "Dépasse tes limites dans cette séance fonctionnelle de haute intensité!",
    ride: "Pédale à fond et repousse tes limites."
  },
  hora: {
    open: "OUVERTURE-MIDI",
    day: "MIDI-15:30",
    close: "15:30-FERMETURE"
  }
};

// Register French bundle into i18n
if (i18n && typeof i18n.addResourceBundle === 'function') {
  i18n.addResourceBundle('fr', 'translations', frClassManagerTranslations, true, true);
  i18n.addResourceBundle('fr-ca', 'translations', frClassManagerTranslations, true, true);
}

function isFrenchMode(props) {
  const cookieLocale = (document.cookie.match(/(?:^|; )locale=([^;]+)/) || [])[1] || '';
  const propLocale = (props && props.config && props.config.locale) || '';
  const htmlLang = (document.documentElement && document.documentElement.lang) || '';
  const navEl = document.querySelector('.header__nav, .nav, header, nav, body');
  const navText = navEl ? navEl.innerText : '';

  if (cookieLocale.toLowerCase().startsWith('fr')) return true;
  if (propLocale.toLowerCase().startsWith('fr')) return true;
  if (htmlLang.toLowerCase().startsWith('fr')) return true;
  if (navText.includes('MON PROFIL') || navText.includes('MES COURS') || navText.includes('INVITER UN AMI')) return true;
  return false;
}

const EXACT_REPLACEMENTS = [
  { from: /^MY RESERVATIONS$/i, to: "MES RÉSERVATIONS" },
  { from: /^My Reservations$/i, to: "MES RÉSERVATIONS" },
  { from: /^Find Classes At$/i, to: "Trouver des cours à" },
  { from: /^[•\+–-]?\s*EDIT OR ADD LOCATIONS$/i, to: "+ MODIFIER OU AJOUTER DES EMPLACEMENTS" },
  { from: /^[•\+–-]?\s*Edit or Add Locations$/i, to: "+ MODIFIER OU AJOUTER DES EMPLACEMENTS" },
  { from: /^CATEGORY$/i, to: "CATÉGORIE" },
  { from: /^INSTRUCTOR$/i, to: "INSTRUCTEUR" },
  { from: /^CLASS$/i, to: "COURS" },
  { from: /^TIME$/i, to: "HEURE" },
  { from: /^FAVORITES$/i, to: "FAVORIS" },
  { from: /^LOCATION$/i, to: "EMPLACEMENT" },
  { from: /^Having trouble booking classes\??$/i, to: "Tu as de la difficulté à réserver des cours ?" },
  { from: /^Wednesday$/i, to: "Mercredi" },
  { from: /^Thursday$/i, to: "Jeudi" },
  { from: /^Friday$/i, to: "Vendredi" },
  { from: /^Saturday$/i, to: "Samedi" },
  { from: /^Sunday$/i, to: "Dimanche" },
  { from: /^Monday$/i, to: "Lundi" },
  { from: /^Tuesday$/i, to: "Mardi" },
  { from: /^Fully Booked$/i, to: "Complet" },
  { from: /^RESERVE A SPOT$/i, to: "RÉSERVER UNE PLACE" },
  { from: /^Reserve A Spot$/i, to: "RÉSERVER UNE PLACE" },
  { from: /^RESERVE$/i, to: "RÉSERVER" },
  { from: /^Reserve$/i, to: "RÉSERVER" },
  { from: /^The Best Fitness, Workout & Exercise Classes$/i, to: "Les meilleurs cours d’entraînement en groupe" },
  { from: /^Download our IOS Member App for easy access to Online Crunch Reservations$/i, to: "Télécharge notre appli membre sur iOS pour accéder facilement aux réservations Crunch en ligne" },
  { from: /^Download our Android Member App for easy access to Online Crunch Reservations$/i, to: "Télécharge notre appli membre sur Android pour accéder facilement aux réservations Crunch en ligne" },
  { from: /^Download this week's class schedule$/i, to: "Télécharge l'horaire des cours de cette semaine" },
  { from: /^Download this week's HIITZone class schedule$/i, to: "Télécharge l'horaire des cours HIITZone de cette semaine" },
  { from: /^classes found$/i, to: "cours trouvés" },
  { from: /^Spots Left$/i, to: "places restantes" }
];

const WEEKDAY_MAP = {
  Sunday: { full: "Dimanche", abbrv: "Dim", letter: "Di" },
  Monday: { full: "Lundi", abbrv: "Lun", letter: "L" },
  Tuesday: { full: "Mardi", abbrv: "Mar", letter: "Ma" },
  Wednesday: { full: "Mercredi", abbrv: "Mer", letter: "Me" },
  Thursday: { full: "Jeudi", abbrv: "Jeu", letter: "J" },
  Friday: { full: "Vendredi", abbrv: "Ven", letter: "V" },
  Saturday: { full: "Samedi", abbrv: "Sam", letter: "S" }
};

function translateDOM(container, isFrench) {
  if (!container || !isFrench) return;

  // 1. Text node replacements
  const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null, false);
  let node;
  while ((node = walker.nextNode())) {
    let val = node.nodeValue;
    const trimmed = val.trim();
    if (!trimmed) continue;

    // Pattern matching
    if (/(\d+)\s+classes found/i.test(trimmed)) {
      node.nodeValue = val.replace(/(\d+)\s+classes found/gi, "$1 cours trouvés");
      continue;
    }
    if (/(\d+)\s+Spots Left/i.test(trimmed)) {
      node.nodeValue = val.replace(/(\d+)\s+Spots Left/gi, "$1 places restantes");
      continue;
    }
    if (/Want to save your favorite classes.*things at(\.\.\.|…)/i.test(trimmed)) {
      node.nodeValue = "Tu veux sauvegarder tes cours ou instructeurs favoris ? Réserver un cours ? Les membres Crunch peuvent faire tout ça à…";
      continue;
    }

    for (const rule of EXACT_REPLACEMENTS) {
      if (rule.from.test(trimmed)) {
        node.nodeValue = val.replace(rule.from, rule.to);
        break;
      }
    }
  }

  // 2. Weektabs attributes
  const weekTabItems = container.querySelectorAll('.weektabs-days li');
  weekTabItems.forEach(item => {
    const dayname = item.getAttribute('data-dayname');
    if (dayname && WEEKDAY_MAP[dayname]) {
      const mapping = WEEKDAY_MAP[dayname];
      if (item.getAttribute('data-full') !== mapping.full) {
        item.setAttribute('data-full', mapping.full);
        item.setAttribute('data-abbrv', mapping.abbrv);
        item.setAttribute('data-letter', mapping.letter);
        item.setAttribute('aria-label', mapping.full);
      }
    }
  });

  // 3. Edit or add locations button
  const editLocationBtn = container.querySelector('.CCM--open-modal .type--e5');
  if (editLocationBtn && (/edit or add/i.test(editLocationBtn.textContent) || !editLocationBtn.textContent.includes('MODIFIER'))) {
    editLocationBtn.textContent = "+ MODIFIER OU AJOUTER DES EMPLACEMENTS";
  }

  // 4. Header title
  const headerText = container.querySelector('.CCM--header-text');
  if (headerText && /find classes at/i.test(headerText.textContent)) {
    headerText.textContent = "Trouver des cours à";
  }

  // 5. Having trouble booking classes button
  const troubleBtn = container.querySelector('.classes-contact-us .CCM--open-modal span, .CCM--open-modal .type--red');
  if (troubleBtn && /having trouble/i.test(troubleBtn.textContent)) {
    troubleBtn.textContent = "Tu as de la difficulté à réserver des cours ?";
  }

  // 6. Downloads bottom text
  const downloadHeader = container.querySelector('.download-app h1');
  if (downloadHeader && /the best fitness/i.test(downloadHeader.textContent)) {
    downloadHeader.textContent = "Les meilleurs cours d’entraînement en groupe";
  }

  const downloadInfo = container.querySelector('.download-app__info');
  if (downloadInfo && /want to save/i.test(downloadInfo.textContent)) {
    downloadInfo.textContent = "Tu veux sauvegarder tes cours ou instructeurs favoris ? Réserver un cours ? Les membres Crunch peuvent faire tout ça à…";
  }
}

export default class CrunchClassManager extends React.Component {
  constructor(props) {
    super(props);
    this.isFrench = isFrenchMode(props);
    if (this.isFrench) {
      if (i18n && typeof i18n.changeLanguage === 'function') {
        i18n.changeLanguage('fr');
      }
      try {
        moment.locale('fr');
      } catch (e) {}
    }
  }

  componentDidMount() {
    this.isFrench = isFrenchMode(this.props);
    if (this.isFrench) {
      this._runTranslation();
      this.observer = new MutationObserver(() => {
        this._runTranslation();
      });
      if (this.wrapperRef) {
        this.observer.observe(this.wrapperRef, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }

      this.interval = setInterval(() => {
        this._runTranslation();
      }, 150);
    }
  }

  componentDidUpdate() {
    this.isFrench = isFrenchMode(this.props);
    if (this.isFrench) {
      this._runTranslation();
    }
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  _runTranslation = () => {
    if (this.wrapperRef) {
      translateDOM(this.wrapperRef, this.isFrench);
    }
  };

  render() {
    return (
      <div ref={el => { this.wrapperRef = el; }} className="crunch-class-manager-wrapper">
        <OriginalCrunchClassManager {...this.props} />
      </div>
    );
  }
}
